export function initBridge() {
  'use strict';
  window.isIOS = function () {
    if (window._isIOS_ == undefined) { window._isIOS_ = navigator.userAgent.indexOf('iPhone') >= 0 || navigator.userAgent.indexOf('iPad') >= 0 || navigator.userAgent.indexOf('iPod') >= 0; }
    return window._isIOS_;
  };

  window.isAndroid = function () {
    if (window._isAndroid_ == undefined) { window._isAndroid_ = navigator.userAgent.indexOf('Android') > 0; }
    return window._isAndroid_;
  };

  window.isShopeeApp = function () {
    if (window._isShopeeApp_ == undefined) { window._isShopeeApp_ = navigator.userAgent.indexOf('Shopee') >= 0; }
    return window._isShopeeApp_;
  };

  window.isLiveChatSDK = function () {
    if (window._isLiveChatSDK_ == undefined) { window._isLiveChatSDK_ = navigator.userAgent.indexOf('LiveChat') >= 0; }
    return window._isLiveChatSDK_;
  };

  window.getAppVersion = function () {
    try {
      if (isLiveChatSDK()) {
        return parseInt(navigator.userAgent.match(/livechatver=([0-9]+)/i)[1]);
      }
      if (isShopeeApp()) {
        return parseInt(navigator.userAgent.match(/appver=([0-9]+)/i)[1]);
      } else {
        return 0;
      }
    } catch (e) {
      return 0;
    }
  };

  window.getHostAppVersion = function () {
    try {
      return parseInt(navigator.userAgent.match(/appver=([0-9]+)/i)[1]);
    } catch (e) {
      return 0;
    }
  };

  window.BJUtil = {
    navigate: function navigate(targetUrl, inCurrentPage, webNewWindow, additionalConfig, popHistory) {
      const config = additionalConfig || {};

      if (inCurrentPage) {
        config.inCurrentPage = true;
      }

      if (popHistory) {
        config.popHistory = true;
      }

      if (webNewWindow) {
        config.target = '_blank';
      }

      if (targetUrl.startsWith('//')) {
        config.url = location.protocol + targetUrl;
      } else if (targetUrl.startsWith('/')) {
        config.url = location.origin + targetUrl;
      } else {
        config.url = targetUrl;
      }

      bridgeCallHandler('navigate', config, function (response) {});
    },
  };

  window.isShopeeRootUrl = function (url) {
    if (!url) {
      return false;
    }

    if (url === '/') {
      return true;
    }

    return false;
  };

  window.bridgeCallHandler = function (handler, data, cb) {
    if (!isShopeeApp() && !isLiveChatSDK() && window.WebViewJavascriptBridge) {
      delete window.WebViewJavascriptBridge;
    }

    const bridge = window.WebViewJavascriptBridge;
    const bridgeReceiver = window.BJBridgeReceiver;
    data = data || {}; // For RN, we only need url and popHistory in the data, for mweb, we need url, popHistory, inCurrentPage and many other fields.

    function callback(obj) {
      try {
        const error = obj && obj.error;
        // 动态下载失败
        if (error === -99 && window.ShopeeChatbot && window.ShopeeChatbot.putInReportQueue) {
          setTimeout(() => {
            window.ShopeeChatbot.putInReportQueue({
              type: 'count',
              value: { label: 'download_dynamic_module_failed' },
            });
          }, 3000);
        }

        if (cb && typeof cb === 'function') {
          cb.apply(this, arguments);
        }
      } catch (e) {}
    }
    // 在其他app拦截 load ,save 和clear
    if (handler == 'load' || handler == 'save' || handler == 'clear') {
      if (!isShopeeApp()) {
        callback({ error: 1 });
        return;
      }
    }
    if (handler == 'navigate') {
    // check if the page this url goes to is RN-enabled, if yes, directly go to RN.
      if (window.RNUtil && window.RNUtil.jumpToReactNativeIfExists(data.url, data.popSelf || data.popHistory || data.inCurrentPage)) {
        return;
      }

      if (isShopeeApp() && isShopeeRootUrl(data.url)) {
        bridgeCallHandler('jump', { path: 'home' }, null);
        return;
      }

      if (data.popHistory) {
        window.location.replace(data.url);
        return;
      } else if (data.inCurrentPage) {
        window.location.href = data.url;
        return;
      }
    } else if (handler == 'load') {
    // Tricky: Due to one Andorid bug, 'load' will not give back callback sometime,
    // eg. when the page is in background.
    // Must specify handler ID, otherwise will override each other.
      if ((isShopeeApp() || isLiveChatSDK()) && isAndroid()) {
        const loadOnce = function () {
          let isDone = false;
          return function (d) {
            if (isDone) { return; }
            isDone = true;
            bridgeUnRegisterHandler('viewWillReappear', callHandler);
            callback(d);
          };
        }();

        var callHandler = function callHandler() {
          bridge.callHandler(handler, data, function (e) {
            loadOnce(e);
          });
        };

        callHandler();
        bridgeRegisterHandler('viewWillReappear', callHandler);
        return;
      }
    } else if (handler === 'popWebView') {
      if (window.DEBUG) {
        console.log('popWebView ' + location.href + ' with data:' + data.data);
      }
    } else if (handler === 'navigateRawUrl') {
    // This is added because navigate command actually mixed with tracking params which has to modify the get params.
    // Since we want to do the navigation directly without doing anything with the url.
    // Then we provide this to achieve the behaviour
      handler = 'navigate';
    }

    if (bridge) {
      bridge.callHandler(handler, data, callback);
    } else if (bridgeReceiver) {
      bridgeReceiver.callHandler(handler, data, callback);
    }
  };

  window.bridgeRegisterHandler = function (handlerName, callback) {
    const bridge = window.WebViewJavascriptBridge;
    const bridgeReceiver = window.BJBridgeReceiver;

    if (bridge) {
      bridge.registerHandler(handlerName, callback);
    } else if (bridgeReceiver) {
      bridgeReceiver.registerHandler(handlerName, callback);
    }
  };

  window.bridgeUnRegisterHandler = function (handlerName, handler) {
    const bridge = window.WebViewJavascriptBridge;
    const bridgeReceiver = window.BJBridgeReceiver;

    if (bridge) {
      bridge.unregisterHandler(handlerName, handler);
    } else if (bridgeReceiver) {
      bridgeReceiver.unRegisterHandler(handlerName);
    }
  };
  'use strict';

  const CUSTOM_PROTOCOL_SCHEME = 'wvjbscheme';
  const QUEUE_HAS_MESSAGE = '__WVJB_QUEUE_MESSAGE__';

  (function () {
    const MARKETPLACE_JS_VERSION = 2;

    window.inBeeShop = function () {
      return window.navigator.userAgent.toLowerCase().indexOf('beeshop') != -1;
    };

    if (window.navigator.userAgent.indexOf('Beeshop') == -1 && !window.isLiveChatSDK()) {
      return;
    } // Note: We check version is because IOS will inject a legacy WebViewJavascriptBridge,
    // which does not have some function like addHook and crash our js


    if (window.WebViewJavascriptBridge && window.WebViewJavascriptBridge._version >= MARKETPLACE_JS_VERSION) {
      return;
    }

    let messagingIframe;
    let sendMessageQueue = [];
    let receiveMessageQueue = [];
    let messageHandlers = {};
    let responseCallbacks = {};
    let uniqueId = 1;

    function reset() {
      sendMessageQueue = [];
      receiveMessageQueue = [];
      messageHandlers = {};
      responseCallbacks = {};
      uniqueId = 1;
      window.WebViewJavascriptBridge._messageHandler = null;
    }

    function _createQueueReadyIframe(doc) {
      messagingIframe = doc.createElement('iframe');
      messagingIframe.style.display = 'none';
      messagingIframe.src = CUSTOM_PROTOCOL_SCHEME + '://' + QUEUE_HAS_MESSAGE;
      doc.documentElement.appendChild(messagingIframe);
    }

    function init(messageHandler) {
      if (window.WebViewJavascriptBridge._messageHandler) {
      // it's not really an error, fix for many duplicate call cases
        console.warn('WebViewJavascriptBridge.init called twice');
        return null;
      }

      window.WebViewJavascriptBridge._messageHandler = [messageHandler];
      const receivedMessages = receiveMessageQueue;
      receiveMessageQueue = null;
      setTimeout(function () {
        for (let i = 0; i < receivedMessages.length; i++) {
          _dispatchMessageFromObjC(receivedMessages[i]);
        }
      }, 0);
    }

    function send(data, responseCallback) {
      _doSend({ data: data }, responseCallback);
    }

    function registerHandler(handlerName, handler) {
      if (typeof messageHandlers[handlerName] === 'undefined') {
        messageHandlers[handlerName] = [];
      }

      messageHandlers[handlerName].push(handler); // We have to do this because Android app will only call hasHandler once inside pageFinished(), and thus later handlers won't be able to register with Android if we don't do this.

      hasHandlerCB(handlerName);
    }

    function unregisterHandler(handlerName, handler) {
      if (!handler) { return; }
      const handlers = messageHandlers[handlerName];
      if (!handlers) { return; }
      const index = handlers.indexOf(handler);

      if (index >= 0) {
      // 这里修改为不使用直接删除，如果在事件运行过程中删除事件，可能会导致部分事件无法正常运行
      // 举例：在响应 viewWillReappear 时，执行注册好的事件 A B C
      // 由于下方执行事件时使用 for 循环遍历，导致如果 B 被删除，C 可能也无法被执行
      // handlers.splice(index, 1);
        handlers[index] = undefined;
      }

      if (handlers.length === 0) {
        delete messageHandlers[handlerName];
        hasHandlerCB(handlerName);
      }
    }

    const hooks_map = {};

    function addHook(hookFunc) {
      const key = hookFunc.toString();
      if (hooks_map[key]) { return; }
      hooks_map[key] = hookFunc;
    }

    function delHook(hookFunc) {
      const key = hookFunc.toString();
      delete hooks_map[key];
    }

    function callHandler(handlerName, data, responseCallback) {
      for (const k in hooks_map) {
        if (!hooks_map.hasOwnProperty(k)) { continue; }

        try {
          hooks_map[k](handlerName, data);
        } catch (ex) {}
      } // !!! When going to full-screen mode, we MUST provide non-webp URL because we do NOT want user to save webp file and share later due to its limited support on iOS devices.


      if (handlerName == 'fullScreenImage' && data) {
        const imageUrls = data.imageUrls;

        if (imageUrls && imageUrls.length) {
          try {
            for (let i = 0; i < imageUrls.length; i++) {
              const url = imageUrls[i];
              if (typeof url !== 'string' || url.indexOf(window.ITEM_IMAGE_BASE_URL) < 0) { continue; }
              imageUrls[i] = url.replace('/webp/', '/');
            }
          } catch (e) {}
        }
      }

      _doSend({
        handlerName: handlerName,
        data: data,
      }, responseCallback);
    }

    function _doSend(message, responseCallback) {
    // Skip bridge cmd if app has pending page update.
      if (window.__appHasPendingCacheUpdate__) { return; } // if(destroyed) return;

      if (responseCallback) {
        const callbackId = 'cb_' + uniqueId++ + '_' + Date.now();
        responseCallbacks[callbackId] = responseCallback;
        message.callbackId = callbackId;
      }

      if (window.navigator.userAgent.toLowerCase().indexOf('android') == -1) // ios
      {
        sendMessageQueue.push(message);
        messagingIframe.src = CUSTOM_PROTOCOL_SCHEME + '://' + QUEUE_HAS_MESSAGE;
      } else {
        window.gabridge.sendMsg(JSON.stringify(message));
      }
    }

    function _fetchQueue() {
      const messageQueueString = JSON.stringify(sendMessageQueue);
      sendMessageQueue = []; // if(destroyed) return [];

      return messageQueueString;
    }

    function _dispatchMessageFromObjC(messageJSON) {
    // Skip bridge cmd if app has pending page update.
      if (window.__appHasPendingCacheUpdate__) { return; } // if(destroyed) return;

      try {
        var message = JSON.parse(messageJSON);
      } catch (err) {
        var message = {};
        console.warn('Bridge dispatch failed. err = ' + err);
      }

      let messageHandler;

      if (message.responseId) {
        var responseCallback = responseCallbacks[message.responseId];

        if (!responseCallback) {
          return;
        } // isCBInProgress = true;


        responseCallback(message.responseData); // isCBInProgress = false;

        delete responseCallbacks[message.responseId];
      } else {
        var responseCallback;

        if (message.callbackId) {
          const callbackResponseId = message.callbackId;

          responseCallback = function responseCallback(responseData) {
            _doSend({
              responseId: callbackResponseId,
              responseData: responseData,
            });
          };
        }

        let handler = window.WebViewJavascriptBridge._messageHandler;

        if (message.handlerName) {
          handler = messageHandlers[message.handlerName];
        }

        if (typeof handler === 'undefined') { return; } // isCBInProgress = true;

        for (const k in handler) {
          if (!handler.hasOwnProperty(k)) { continue; }

          try {
            handler[k](message.data, responseCallback);
          } catch (exception) {
            if (typeof console !== 'undefined') {
              console.log('WebViewJavascriptBridge: WARNING: javascript handler threw.', message, exception);
            }
          }
        } // isCBInProgress = false;

        try {
          if (message.handlerName) {
          // 由于修改了 unregister 方法，使得方法被置为 undefined，没有直接删除，这里在遍历执行后，删除 undefined 的方法
            messageHandlers[message.handlerName] = messageHandlers[message.handlerName].filter(i => i);
          }
        } catch (exception) {}
      }
    }

    function _handleMessageFromObjC(messageJSON) {
      if (receiveMessageQueue) {
        receiveMessageQueue.push(messageJSON);
      } else {
        _dispatchMessageFromObjC(messageJSON);
      }
    }

    function hasHandler(handlerName) {
      let has = false;

      try {
        has = messageHandlers[handlerName] != null;
      } catch (exception) {
        has = false;
      } // On iOS, return String value only!


      return has ? 'true' : 'false';
    }

    function hasHandlerCB(handlerName) {
      if (!window.gabridge || !window.gabridge.onHasHandler) { return; } // On Android, DO NOT RETURN ANYTHING!
      // Because Android can only call JS by loadUrl('javascript:....'), returned values WILL BECOME THE WEBPAGE AND WILL BE DISPLAYED!!!

      window.gabridge.onHasHandler(handlerName, hasHandler(handlerName));
    } // !!! NOTE: Currently only supported by iOS app >= 2.3. NOT SUPPORTED BY ANDROID APP!!!
    // This is a new way for App to inject handler definitions directly into JS context on page load.
    // In this way, JS won't need to chain callbacks for .callHandler('hasHandler', {handler: <handler>}, function(){.callHandler('<handler>', ... function(){});});
    // Chained JS calls could freeze iOS app if page reloads during the chained calls.


    function appHasHandler(name) {
      return window.WebViewJavascriptBridgeiOSNativeAppConfig ? window.WebViewJavascriptBridgeiOSNativeAppConfig._appHandlers && window.WebViewJavascriptBridgeiOSNativeAppConfig._appHandlers.indexOf(name) >= 0 : window.WebViewJavascriptBridge._appHandlers && window.WebViewJavascriptBridge._appHandlers.indexOf(name) >= 0;
    }

    window.WebViewJavascriptBridge = {
      init: init,
      send: send,
      registerHandler: registerHandler,
      unregisterHandler: unregisterHandler,
      callHandler: callHandler,
      hasHandler: hasHandler,
      hasHandlerCB: hasHandlerCB,
      addHook: addHook,
      delHook: delHook,
      appHasHandler: appHasHandler,
      _fetchQueue: _fetchQueue,
      _handleMessageFromObjC: _handleMessageFromObjC,
      reset: reset,
      _version: MARKETPLACE_JS_VERSION,
    };

    function triggerIOSAppPageReInit(skipChecking, flushMessageQueue) {
      try {
        if (!skipChecking && (!isIOS() || (!isShopeeApp() && !isLiveChatSDK()))) { return true; }
        if (!window.document || !window.document.documentElement) { return false; }
        const doce = window.document.documentElement; // This is to trigger didFinishLoading of iOS, which will in turn re-init gatap.

        const frm = document.createElement('iframe');
        frm.style.display = 'none'; // This is used after iOS cache invalidation, where we need to both flush message queue and trigger didFinishLoad (this func is called twice in this case).

        if (flushMessageQueue) { frm.src = CUSTOM_PROTOCOL_SCHEME + '://' + QUEUE_HAS_MESSAGE; } // This is the normal case, where we only need to trigger didFinishLoad.
        else { frm.src = 'javascript:void(0)'; }
        doce.appendChild(frm);
        setTimeout(function () {
          doce.removeChild(frm);
        }, 500);
        return true;
      } catch (e) {
        console.log('triggerIOSAppPageReInit_ex', e);
        return true;
      }
    }

    const doc = document;

    _createQueueReadyIframe(doc);

    const readyEvent = doc.createEvent('Events');
    readyEvent.initEvent('WebViewJavascriptBridgeReady');
    readyEvent.bridge = window.WebViewJavascriptBridge;
    doc.dispatchEvent(readyEvent);
    let timerTriggerIOS = null;
    let intervalTriggerIOS = null; // !!! Tricky. When network is really slow, the iOS app's didFinishLoad won't be called soon, and all bridge responses will be pending for a long time.
    // So we wait for 100ms and if iOS app didFinishLoad still hasn't been called, we force to trigger it.

    if (isIOS() && (isShopeeApp() || isLiveChatSDK())) {
    // Wait for 2 secs and start trying.
      timerTriggerIOS = setTimeout(function () {
        timerTriggerIOS = null; // This means didFinishLoad has run.

        if (window.__gawindow__) { return; }
        intervalTriggerIOS = setInterval(function () {
        // This is the magic variable injected by iOS app after didFinishLoad. We use this to detect whether didFinishLoad has been triggered.
          if (window.__gawindow__ || triggerIOSAppPageReInit()) {
            clearInterval(intervalTriggerIOS);
            intervalTriggerIOS = null;
          }
        }, 300);
      }, 2000);
    }
  })();

  (function () {
  // This is to avoid being confused by other Garena apps who natively emit this event but don't handle shopee bridge commands. For example Gas.
    function dismissNonShopeeBridge() {
      if (isShopeeApp() || isLiveChatSDK()) { return false; }
      delete window.WebViewJavascriptBridge;
      return true;
    }

    window.connectWebViewJavascriptBridge = function (callback) {
    // This is to avoid being confused by other Garena apps who natively emit this event but don't handle shopee bridge commands. For example Gas.
      if (dismissNonShopeeBridge()) { return; }

      if (window.WebViewJavascriptBridge) {
        callback(window.WebViewJavascriptBridge);
      } else {
        document.addEventListener('WebViewJavascriptBridgeReady', function () {
        // This is to avoid being confused by other Garena apps who natively emit this event but don't handle shopee bridge commands. For example Gas.
          if (dismissNonShopeeBridge()) { return; }
          callback(window.WebViewJavascriptBridge);
        }, false);
      }
    };
  })();
  'use strict';

  if (!isShopeeApp() && !isLiveChatSDK()) {
    window.BJBridgeReceiver = function () {
      const hasViewWillReappearCallback = false;
      const responseCallbacks = {}; // 模拟app的部分行为

      if (window.DEBUG_APPEAR) {
        document.addEventListener('visibilitychange', function () {
          if (document.visibilityState === 'visible') {
            window.BJBridgeReceiver.triggerBridgeEvent('viewWillReappear');
          } else {
            window.BJBridgeReceiver.triggerBridgeEvent('viewDidDisappear');
          }
        });
      }

      if (window.DEBUG_NAVBAR) {
        const navbar = document.createElement('div');
        navbar.id = 'bridge-debug-navbar';
        navbar.setAttribute('style', 'position:absolute;top:0;width:100%;height:64px;');
        const back = document.createElement('span');
        back.innerText = 'back';
        back.setAttribute('style', 'color:red;font-size:20px;float:left;line-height:64px;padding-left:15px;');
        back.addEventListener('touchend', function () {
          window.BJBridgeReceiver.triggerBridgeEvent('didTapBack');
        });
        navbar.appendChild(back); // var egretDisplay = document.getElementsByClassName('egret-player')[0];
        // if (egretDisplay) {
        // 	egretDisplay.style.height = 'auto';
        // 	egretDisplay.style.top = '64px';
        // 	egretDisplay.style.bottom = '0';
        // }

        document.body.appendChild(navbar);
      }

      function getCallbackId(data) {
        return data.callbackId;
      }
      /**
     * Register a callback with the given command.
     * @param CMD {string}
     * @param callback {function}
     * @returns {string} The callback ID that identifies this callback.
     */


      function registerResponseCallback(CMD, callback) {
        const callbackId = CMD + Date.now(); // Assumption: There won't be multiple callback registrations of
        // the same command at the same time.

        responseCallbacks[callbackId] = function (responseData) {
          callback(responseData);
          delete responseCallbacks[callbackId];
        };

        return callbackId;
      }
      /**
     * Call a registered callback.
     *
     * @param requestData {object} Must contain the callbackId field to retrieve the callback.
     * @param responseData {object} The input to the callback.
     */


      function callCallback(requestData, responseData) {
        const callbackId = getCallbackId(requestData);

        if (callbackId in responseCallbacks) {
          responseCallbacks[callbackId](responseData);
        }
      }
      /**
     * Handles callHandler commands. It will print warning messages in the console
     * if the command is not supported.
     * @param CMD {string}
     * @param data {object} optional
     * @param callback {function} optional
     */


      function dispatchCMD(CMD, data, callback) {
        if (!cmdHandlers[CMD]) {
          console.warn('web Unsupported CMD - ' + CMD);
          throw new Error('web Unsupported CMD - ' + CMD);
        } else {
          if (callback) {
            var callbackId = registerResponseCallback(CMD, callback);
          }

          data.callbackId = callbackId;
          cmdHandlers[CMD](data);
        }
      }
      /**
     * There are two places that handle events. The BJUtil module supports viewWillReappear
     * event and BJBridgeReceiver handles the rest.
     *
     * @param handlerName {string}
     * @param callback {function}
     */


      function registerHandler(handlerName, callback) {
        if (typeof callback !== 'function') {
          return;
        }

        registerBridgeEvent(handlerName, callback);
      }

      function unRegisterHandler(handlerName, callback) {
        if (handlerName in bridgeEvents) {
          if (callback) {
            const index = bridgeEvents[handlerName].indexOf(callback);

            if (index > -1) {
              bridgeEvents[handlerName].splice(index, 1);
            }
          } else {
            bridgeEvents[handlerName] = [];
          }
        }
      }

      var bridgeEvents = {
        onEventCallback: [],
        didTapBack: [],
        tabShow: [],
        viewWillReappear: [],
        viewDidDisappear: [],
      };

      function registerBridgeEvent(name, eventHandler) {
        if (name in bridgeEvents) {
          bridgeEvents[name].push(eventHandler);
        }
      }

      function triggerBridgeEvent(name, data) {
        const event = bridgeEvents[name];

        if (event) {
          event.forEach(function (e) {
            if (typeof e === 'function') {
              e(data);
            }
          });
        } else {
          console.warn('Unsupported Bridge Event - ' + name);
          console.warn(data);
        }
      }

      function getCookie(name) {
        const r = new RegExp('(?:^|;+|\\s+)' + name + '=([^;]*)');
        let m = '';

        if (document) {
          m = document.cookie.match(r);
        }

        return (!m ? '' : m[1]) || null;
      }

      function urlToLocation(url) {
        const link = document.createElement('A');
        link.href = url;
        return link;
      }

      function urlJoin(base, url) {
        try {
          return new URL(url, base).href;
        } catch (error) {}

        const baseObj = urlToLocation(base);

        if (url.startsWith('http://') || url.startsWith('https://')) {
          return url;
        }

        let path = url;

        if (!url.startsWith('/')) {
          path = baseObj.pathname.substr(0, baseObj.pathname.lastIndexOf('/')) + '/' + url;
        }

        return baseObj.origin + path;
      } // --------------------- Bridge CMD handler implementations ---------------
      // TODO handle viewWillReappearHandler in non_modal case

      /**
     * Supported params:
     * data,
     * count (only in pages that are presented modally)
     */


      function popWebView() {
        window.history.back(); // If no more back to go, close self.

        setTimeout(function () {
          if (window.opener != null && window.opener != window) { window.close(); }
        }, 300);
      }
      /**
     * Supported params:
     * url, presentModal, presentModalWebOnly
     *
     * Web specific param:
     * target: if set to _blank, it will open new tab.
     *
     * Note:
     * Navigation strategy (in order of descending precedence)
     * 1. if target is _blank, will open a new page.
     * 2. if presentModal param is set to false, will present modally
     * 3. if this page listens to the viewWillReappear event, will present modally
     * 		(update 20170201: I remove this, because this two events should not affect each other.
     * 						  If needed, the caller should add presentModalWebOnly in the config.
     * 		)
     * 4. Otherwise will do in-page navigation.
     */


      function navigate(data) {
        const url = data.url;

        if (data.target == '_blank') {
          _webNavigate(url, true);
        } else {
          _webNavigate(url);
        }
      }

      function _webNavigate(targetUrl, newWindow) {
        if (window.MALL_HOST_ROOT_URL && targetUrl.indexOf('/') == 0) {
          targetUrl = window.MALL_HOST_ROOT_URL + targetUrl;
        }

        if (newWindow) {
          window.open(targetUrl);
        } else {
          location.href = targetUrl;
        }
      }

      function configureNavBarTitle(data) {
        const title = data.title;

        if (title) {
          document.title = title;
        }
      }
      /**
     * Only support navbar.title and right items with type of button.
     * nav buttons will be added to the btn-bottom-holder. If you'd like to
     * show those buttons, add a div.btn-bottom-holder element to your page.
     */


      function configurePage(data) {
        if (!data.navbar) {
          return;
        }

        if (data.navbar.title) {
          const titleData = { title: data.navbar.title };
          configureNavBarTitle(titleData);
        } // if (window.DEBUG_NAVBAR && data.navbar.isTransparent === 1) {
        // 	var navbar = document.getElementById('bridge-debug-navbar');
        // 	if (navbar) {
        // 		navbar.style.background = 'none';
        // 	}
        // 	var egretDisplay = document.getElementsByClassName('egret-player')[0];
        // 	if (egretDisplay) {
        // 		egretDisplay.style.height = '100%';
        // 		egretDisplay.style.top = null;
        // 		egretDisplay.style.bottom = null;
        // 		if (window.egret && window.egret.updateAllScreens) {
        // 			window.egret.updateAllScreens();
        // 		}
        // 	}
        // }

      }
      /**
     * Data is saved to sessionStorage or localStorage depending on the persist param.
     * Persist == 0 => sessionStorage
     * Persist == 1 => both sessionStorage and localStorage
     */


      function save(data) {
        const key = data.key;
        const value = data.data;
        const persist = data.persist;

        if (key && value) {
          try {
            window.sessionStorage.setItem(key, value);

            if (persist) {
              window.localStorage.setItem(key, value);
            }

            callCallback(data, { status: 1 });
            return;
          } catch (error) {
            console.error('bridge CMD save error: ', error);
          }
        }

        callCallback(data, { status: 0 });
      }

      function load(data) {
        let result;
        const key = data.key;

        if (key) {
          try {
            result = window.sessionStorage.getItem(key);

            if (!result) {
              result = window.localStorage.getItem(key);
            }
          } catch (error) {
            console.error('bridge CMD load error: ', error);
          }
        }

        callCallback(data, { data: result });
      }

      const RouteTypes = {
        USE_GIVEN_PATH: 0,
        // used for matching a pathName to a new path
        USE_ORIGINAL_PATH: 1, // used when a pathName is the path to jump to (useful when pathName contains variable data)

      };
      const UrlByAppRoute = [{
        regex: '^home$',
        type: RouteTypes.USE_GIVEN_PATH,
        path: '/',
      }, {
        regex: '^me$',
        type: RouteTypes.USE_GIVEN_PATH,
        path: '/me/',
      }, {
        regex: '^cart$',
        type: RouteTypes.USE_GIVEN_PATH,
        path: '/buyer/cart/',
      }, {
        regex: '^checkout$',
        type: RouteTypes.USE_GIVEN_PATH,
        path: '/buyer/w/checkout/confirmation/',
      }, {
        regex: '^paid$',
        type: RouteTypes.USE_GIVEN_PATH,
        path: '/me/?page=all',
      }, {
        regex: '^unpaid$',
        type: RouteTypes.USE_GIVEN_PATH,
        path: '/me/',
      }, {
        regex: '^cancelled$',
        type: RouteTypes.USE_GIVEN_PATH,
        path: '/me/',
      }, {
        regex: '^purchases?tab=paid$',
        type: RouteTypes.USE_GIVEN_PATH,
        path: '/me/', // There is no purchase page for web yet. Use 'me' instead

      }, {
        regex: '^/user/groups/$',
        type: RouteTypes.USE_GIVEN_PATH,
        path: '/user/groups/',
      }, {
        regex: '^/user/groups/\\d+$',
        type: RouteTypes.USE_ORIGINAL_PATH,
      }];
      const UrlByPcRoute = [ // Jump to pcmall page
        {
          regex: '^home$',
          type: RouteTypes.USE_GIVEN_PATH,
          path: '/',
        }, {
          regex: '^me$',
          type: RouteTypes.USE_GIVEN_PATH,
          path: '/me/',
        }, {
          regex: '^cart$',
          type: RouteTypes.USE_GIVEN_PATH,
          path: '/cart/',
        }, {
          regex: '^checkout$',
          type: RouteTypes.USE_GIVEN_PATH,
          path: '/checkout/',
        }, {
          regex: '^paid$',
          type: RouteTypes.USE_GIVEN_PATH,
          path: '/user/purchase/list/?type=7',
        }, {
          regex: '^unpaid$',
          type: RouteTypes.USE_GIVEN_PATH,
          path: '/user/purchase/list/?type=9',
        }, {
          regex: '^cancelled$',
          type: RouteTypes.USE_GIVEN_PATH,
          path: '/user/purchase/list/?type=4',
        }, {
          regex: '^mycard$',
          type: RouteTypes.USE_GIVEN_PATH,
          path: '/user/account/payment',
        }, {
          regex: '^purchases?tab=paid$',
          type: RouteTypes.USE_GIVEN_PATH,
          path: '/me/', // There is no purchase page for web yet. Use 'me' instead

        }, {
          regex: '^/user/groups/$',
          type: RouteTypes.USE_GIVEN_PATH,
          path: '/user/groups/',
        }, {
          regex: '^/user/groups/\\d+$',
          type: RouteTypes.USE_ORIGINAL_PATH,
        },
      ];
      const UrlByLiteRoute = [ // Jump to Lite page
        {
          regex: '^/order/success/\\d+$',
          type: RouteTypes.USE_ORIGINAL_PATH,
        }, {
          regex: '^paid$',
          type: RouteTypes.USE_GIVEN_PATH,
          path: '/user/purchase?type=7',
        }, {
          regex: '^unpaid$',
          type: RouteTypes.USE_GIVEN_PATH,
          path: '/user/purchase',
        },
      ];
      /**
     * Difference from App version: navigation history is preserved.
     * It's impossible to clear navigation history using JS.
     * All supported app routes are in the UrlByAppRoute dictionary.
     */

      function jump(data) {
        const queryIndex = data.path.indexOf('?');
        let pathName = data.path;
        let query = '';

        if (queryIndex > -1) {
          pathName = data.path.slice(0, -1);
          query = pathArr[1];
        }

        if (data.pcmallBaseUrl) {
        // If given pcmall url, jump to Pcmall routh with given base_url
          pathName = urlJoin(data.pcmallBaseUrl, getPcPath(pathName) || pathName);
        } else if (data.liteBaseUrl) {
          pathName = urlJoin(data.liteBaseUrl, getLitePath(pathName) || pathName);
        } else {
          pathName = getAppPath(pathName);
        }

        if (pathName) {
          _webNavigate(pathName + query);
        } else {
          console.error(('Unsupported AppRoute on web - {0}.' + ' Refer to UrlByAppRoute in BJBridgeReceiver.js for supported routes.').f(data.path));
        }
      }

      function getPath(pathName, routeArr) {
        for (let i = 0; i < routeArr.length; i++) {
          const routeObj = routeArr[i];
          const regex = routeObj.regex;

          if (pathName.match(regex)) {
            switch (routeObj.type) {
              case RouteTypes.USE_GIVEN_PATH:
                return routeObj.path;

              case RouteTypes.USE_ORIGINAL_PATH:
                return pathName;

              default:
                return null;
            }
          }
        }

        return null;
      }
      /**
     * Given a pathName get the pc mall path to jump to
     * If no valid path to jump to, return null
     * @param pathName
     * @returns {string|null}
     */


      function getPcPath(pathName) {
        return getPath(pathName, UrlByPcRoute);
      }
      /**
     * Given a pathName get the lite path to jump to
     * If no valid path to jump to, return null
     * @param pathName
     * @returns {string|null}
     */


      function getLitePath(pathName) {
        return getPath(pathName, UrlByLiteRoute);
      }
      /**
     * Given a pathName get the app path to jump to
     * If no valid path to jump to, return null
     * @param pathName
     * @returns {string|null}
     */


      function getAppPath(pathName) {
        return getPath(pathName, UrlByAppRoute);
      }

      function login(data) {
        let redirectUrl;

        if (data) {
          switch (data.redirectTab) {
            case 1:
              redirectUrl = '/buyer/login/';
              break;

            case 0:
              redirectUrl = '/buyer/login/signup/';
              break;

            default:
              redirectUrl = '/buyer/login/signup/';
          }
        } else {
          redirectUrl = '/buyer/login/signup/';
        }

        _webNavigate(redirectUrl);
      }

      function share(data) {
        callCallback(data, data);
      }

      function getAppInfo(requestData) {
        const responseData = {};
        responseData.deviceID = null;
        responseData.deviceFingerprint = getCookie('SPC_F');
        responseData.BCAXOWidgetDeviceID = 'WEB'; // 'WEB' is a placeholder value for PC only; for apps, it will be the actual device id requested by BCA

        callCallback(requestData, responseData);
      }

      function copyTextToClipboard(data) {
        const text = data.text;

        if (window.clipboardData && window.clipboardData.setData) {
        // IE specific code path to prevent textarea being shown while dialog is visible.
          return clipboardData.setData('Text', text);
        } else if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
          const textarea = document.createElement('textarea');
          textarea.textContent = text;
          textarea.style.position = 'fixed'; // Prevent scrolling to bottom of page in MS Edge

          document.body.appendChild(textarea);
          textarea.select();

          try {
            if (document.execCommand('copy')) {
              callCallback(data);
            } else {
              callCallback(data, 'error');
            } // Security exception may be thrown by

          } catch (ex) {
            console.warn('Copy to clipboard failed.', ex);
            callCallback(data, 'error');
            return false;
          } finally {
            document.body.removeChild(textarea);
          }
        }
      }
      /**
     * All supported bridge commands are here.
     */


      var cmdHandlers = {
        popWebView: popWebView,
        navigate: navigate,
        configureNavBarTitle: configureNavBarTitle,
        configurePage: configurePage,
        save: save,
        load: load,
        jump: jump,
        getAppInfo: getAppInfo,
        login: login,
        share: share,
        copyTextToClipboard: copyTextToClipboard,
      };
      return {
        callHandler: dispatchCMD,
        registerHandler: registerHandler,
        unRegisterHandler: unRegisterHandler,
        callCallback: callCallback,
        triggerBridgeEvent: triggerBridgeEvent,
      };
    }();
  }

  // 调整bridgeInit函数定义位置在connectWebViewJavascriptBridge定义之后，不然setTimeout轮询调用bridgeInit的时候，connectWebViewJavascriptBridge可能还没定义
  window.bridgeInit = function () {
    let initDone = false;
    return function (callback) {
      if (!callback || typeof callback !== 'function') {
        return;
      }

      if (isShopeeApp() || isLiveChatSDK()) {
        connectWebViewJavascriptBridge(function (bridge) {
          if (!initDone) {
            bridge.init(function () {});
            initDone = true;
          }

          callback(bridge);
        });
      } else {
        callback();
      }
    };
  }();

  /**
 * <!--
    fix click event trigger abnormal after loading above four JSBridge support js files
  -->
*/
  function baseBridgeCall() {
    try {
      if (!window.bridgeInit || !window.bridgeRegisterHandler) {
        return setTimeout(baseBridgeCall, 200);
      }

      window.bridgeInit(function() {
        window.bridgeCallHandler('configurePage', {
          config: {
            disableReload: 1,
            disableSwipeBack: 1,
            disableBounce: 1,
          },
          navbar: {
            isTransparent: 1,
            hideBackButton: 1,
          },
        });
      });
    } catch (err) {
    // do nothing
    }
  }
  baseBridgeCall();
}
